import React, { useState, useEffect } from "react";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../constants/assets/containers";
import NoFooterModal from "../Common/NoFooterModal";
import Permission from "../Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { getInitialState, isValNull, removeEmptyVals } from "../../utils";
import PaginatedReactDropdown from "../Common/PaginatedReactDropdown";
import {
  getChatDepartmentById,
  getChatDepartments,
  resetState,
  upsertChatDepartment,
} from "../../store/actions/ChatDepartments";
import { getCity, getCityList } from "../../store/actions/City";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import InfiniteScrollDropdown from "../Common/InfiniteScrollDropdown";
import { setStatus } from "../../store/actions/User";
import { getIssueTypeRemoteSearch } from "../../store/actions/SubIssueTypes";
import { getIssueTypeList } from "../../store/actions/IssueTypes";

const enableOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" },
];

const ChatDepartmentsModal = ({
  modalState,
  handleClose,
  getCity,
  getCityList,
  nextPageCity,
  activeFilters,
  activeChatDepartment,
  activeId,
  getChatDepartmentById,
  getChatDepartments,
  resetState,
  setStatus,
  upsertChatDepartment,
  currentPage,
  getIssueTypeRemoteSearch,
  remoteSearch,
}) => {
  const allActions = MenuActionsMappings[MenuNames.LOGISTICS_CHAT_DEPARTMENTS];
  const [initialState, setInitialState] = useState({
    cityName: "",
    departmentName: "",
    rank: "",
    enabled: "",
    priority: "",
    issueTypeName: "",
  });

  const handleSubmit = () => {
    if (modalState === "Filter") {
      let filters = {};
      Object.keys(initialState).forEach((key) => {
        if (!isValNull(initialState[key])) {
          filters[key] = initialState[key];
        }
      });
      getChatDepartments(filters).then((res) => {
        handleClose();
      });
      return;
    }
    if (!initialState["departmentName"]) {
      setStatus({ type: "error", message: "Please enter department name" });
      return;
    }
    const payload = removeEmptyVals({
      city_name: initialState.cityName,
      department_name: initialState.departmentName,
      issue_type_name: initialState.issueTypeName,
      rank: initialState.rank,
      enabled: initialState.enabled,
      priority: initialState.priority,
    });
    if (modalState === "Edit") {
      payload["id"] = activeChatDepartment.id;
      upsertChatDepartment(payload).then((_) => {
        const pageRequest = {
          page: currentPage,
        };
        getChatDepartments(activeFilters, pageRequest);
        handleClose();
      });
    } else {
      upsertChatDepartment(payload).then((_) => {
        const pageRequest = {
          page: 1,
        };
        getChatDepartments(activeFilters, pageRequest);
        handleClose();
      });
    }
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    if (key === "rank") {
      values[key] = Number(val);
    } else {
      values[key] = val;
    }
    setInitialState(values);
  };

  const getRequiredButtonPerms = (action = undefined) => {
    if (modalState === "Edit" || modalState === "Add") {
      return [allActions.UPDATE];
    }
    return undefined;
  };

  const handleClearFilters = () => {
    getChatDepartments({}).then((res) => {
      resetState({ state: "activeFilters" });
      handleClose();
    });
  };

  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" && (
          <Button
            data-testid="filterChatDeptBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitChatDeptButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };

  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find(
      (item) => item[fromKey] === (isNumber ? parseInt(val) : val)
    );
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  const getPriorityFlagVal = () => {
    if (modalState === "Edit") {
      return false;
    } else if (
      modalState === "Filter" &&
      Object.keys(activeFilters).length > 0 &&
      !isValNull(activeFilters["cityName"])
    ) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (activeId) {
      getChatDepartmentById(activeId);
    }
  }, [activeId, modalState]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeChatDepartment && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = !isValNull(activeChatDepartment[key])
          ? activeChatDepartment[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = !isValNull(activeFilters[key]) ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activeChatDepartment, activeFilters]);

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Chat Department`}
      handleClose={handleClose}
      id="ChatDeptFormModal"
      modalButtons={getModalButtons()}
    >
      <Input
        value={initialState.departmentName}
        data-testid="departmentName"
        id="sushi-input"
        onChange={(e) => handleChange("departmentName", e)}
        label="Department name"
      />
      <InfiniteScrollDropdown
        id="cityNameChatDept"
        appliedFilters={{}}
        priorityFlag={getPriorityFlagVal()}
        getActiveList={getCityList}
        nextPage={nextPageCity}
        defaultVal={
          initialState.cityName ? { city_name: initialState.cityName } : ""
        }
        value={null}
        resKey="cities"
        modalState={modalState}
        keyName="cityName"
        labelKey="city_name"
        getDataLabelKey="city.city_name"
        keyTypeToSet="city_name"
        label="City"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        activeFilters={activeFilters}
        activeElement={activeChatDepartment}
        getActiveItemById={getCity}
      />
      <InfiniteScrollDropdown
        id="issueTypeChatDepartments"
        priorityFlag={true}
        getActiveList={getIssueTypeRemoteSearch}
        nextPage={remoteSearch.nextPage}
        defaultVal={
          initialState.issueTypeName
            ? { issue: initialState.issueTypeName }
            : ""
        }
        resKey="data" // key to get the list
        keyName="issueTypeName"
        modalState={modalState}
        labelKey="issue" // key for label
        getDataLabelKey="issueType"
        keyTypeToSet="issue" // key to return the data of
        label="Issue Type"
        handleChange={handleChange}
        activeElement={activeChatDepartment}
        getActiveItemById={getIssueTypeRemoteSearch}
        appliedFilters={{}}
        width="50%"
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
      />
      {modalState !== "Filter" && (
        <Input
          value={initialState.rank}
          data-testid="issueTypeNameChatDept"
          type="number"
          id="sushi-input"
          onChange={(e) => handleChange("rank", e)}
          label="Rank"
        />
      )}
      <FlexContainer justify="flex-start">
        <PaginatedReactDropdown
          options={enableOptions}
          data-testid="chatDeptEnabled"
          labelKey="label"
          valueKey="key"
          value={getInputLabel(
            initialState.enabled,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="20%"
          handleChange={handleChange}
          keyToChange="enabled"
          placeholder="Enabled"
          showCross={true}
          id="chatDeptEnabled"
        />
        <PaginatedReactDropdown
          options={enableOptions}
          data-testid="chatDeptPriority"
          labelKey="label"
          valueKey="key"
          value={getInputLabel(
            initialState.priority,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="20%"
          handleChange={handleChange}
          keyToChange="priority"
          placeholder="Priority"
          showCross={true}
          id="chatDeptPriority"
        />
      </FlexContainer>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { City, ChatDepartments, IssueTypes } = state;
  return {
    cityList: City.cityList,
    nextPageCity: City.nextPage,
    currentPage: ChatDepartments.currentPage,
    activeChatDepartment: ChatDepartments.activeChatDepartment,
    activeFilters: ChatDepartments.activeFilters,
    issueTypeList: IssueTypes.issueTypeList,
    nextPageIssueTypes: IssueTypes.nextPage,
    remoteSearch: IssueTypes.remoteSearch,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    upsertChatDepartment: bindActionCreators(upsertChatDepartment, dispatch),
    getCity: bindActionCreators(getCity, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
    getChatDepartmentById: bindActionCreators(getChatDepartmentById, dispatch),
    getChatDepartments: bindActionCreators(getChatDepartments, dispatch),
    resetState: bindActionCreators(resetState, dispatch),
    setStatus: bindActionCreators(setStatus, dispatch),
    getIssueTypeRemoteSearch: bindActionCreators(
      getIssueTypeRemoteSearch,
      dispatch
    ),
    getIssueTypeList: bindActionCreators(getIssueTypeList, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatDepartmentsModal);
